import { GuardChatStore } from "./types";

export default function getDefaultState(): GuardChatStore {
	return {
		guardChatList: {},
		activeMessagesEventId: 0
	}
}